<template>
  <div>



    <!-- Affichage des descriptifs des plans -->
    <div v-if="planTransactionData.transactionStatusCode === '055'" class="block">
      <div v-if="processState === 'ViewPlanList'" class="block">
        <div  class="col-sm-12">
          <h2 class="content-heading align-center">{{textSubscriptionDescriptionTitle01[actualLanguage]}}</h2>
          <h6  class="font-w200 text-center push">{{textSubscriptionDescriptionText01[actualLanguage]}}</h6>
          <h6  class="font-w200 text-center push">{{textSubscriptionDescriptionText02[actualLanguage]}}</h6>
          <h6  class="font-w200 text-center push">{{textSubscriptionDescriptionText03[actualLanguage]}}</h6>
          <h6  class="font-w200 text-center push">{{textSubscriptionDescriptionText04[actualLanguage]}}</h6>
          <h6  class="font-w200 text-center push">{{textSubscriptionDescriptionText05[actualLanguage]}}</h6>
        </div>

        <div v-if="false"  class="col-sm-12">
          <h2 class="content-heading align-center">{{textSubscriptionDescriptionTitle02[actualLanguage]}}</h2>
          <h6  class="font-w200 text-center push">{{textSubscriptionDescriptionText11[actualLanguage]}}</h6>
          <h6  class="font-w200 text-center push">{{textSubscriptionDescriptionText12[actualLanguage]}}</h6>
        </div>



        <div v-if="false" class="col-sm-12">
          <h2 class="content-heading align-center">{{textSubscriptionDescriptionTitle03[actualLanguage]}}</h2>              
          <p><button @click="openAdministratorDocumentation()" type="button" class="btn btn-block btn-success" name="button"><i class="fa fa-question-circle fa-1x push-10-r "></i> {{ buttonLabelPlatformDucumentationExplanation[actualLanguage] }}</button></p>
        </div>


        <div v-if= "flagShowPlanList">
           
          <div v-for="(planLine, index) in planDescription" :key="index" class="col-xm-12 col-md-12">
              <!-- Startup Plan -->

              <a class="block block-bordered block-link-hover3 text-center" href="javascript:void(0)">
                  <div class="block-header">
                      <h2 class="font-w200 text-center">{{planLine.planInfo.title[actualLanguage]}}</h2>

                      <div v-for="(descriptionLine, index) in planLine.planInfo.description" :key="index" class="col-xm-12 col-md-12">
                        <h6  class="font-w200 text-center push">{{descriptionLine[actualLanguage]}}</h6>
                      </div>
                      <hr size="50">

                      <h4  class="font-w200 text-center">{{textSubscriptionOrgLicenceSection[actualLanguage]}}</h4>
                      <h6  class="font-w200 text-center push">{{planLine.organizationLicenceData.licenceTitle[actualLanguage]}}</h6>
                      <h6  class="font-w200 text-center">{{planLine.organizationLicenceData.priceDescription[actualLanguage]}} : </h6>
                      <h5  class="h1 font-w700 push-10">{{planLine.organizationLicenceData.price}} $ </h5>
                      <div v-if="planLine.organizationLicenceData.options.length > 100">
                          <h5  class="content-heading align-center">{{textSubscriptionLicenceOptionSection[actualLanguage]}}</h5>
                          <div v-for="(optionLine, optionIndex) in planLine.organizationLicenceData.options" :key="optionIndex" class="col-xm-12 col-md-12">
                            <h5 class="font-w200 text-center">{{optionLine.title[actualLanguage]}}</h5>

                            <h6  class="font-w200 text-center">{{optionLine.description[actualLanguage]}}</h6>
                            <h6  class="font-w200 text-center">{{optionLine.priceDescription[actualLanguage]}}</h6>
                            <h6  class="h3 font-w700 push-10">{{optionLine.price}} $ </h6>
                            
                          </div>
                      </div>


                      <hr size="50">

                      <div class="col-sm-12 push" v-if="parseFloat(planLine.planInfo.maximumLicenceCount) > parseFloat(planLine.planInfo.includedLicence)">
                        <h4  class="font-w200 text-center">{{textSubscriptionUserLicenceSection[actualLanguage]}}</h4>
                        <h6  class="font-w200 text-center push">{{planLine.userLicenceData.licenceTitle[actualLanguage]}}</h6>
                        <h6  class="font-w200 text-center">{{planLine.userLicenceData.priceDescription[actualLanguage]}} : </h6>
                        <h5  class="h1 font-w700 push-10">{{planLine.userLicenceData.price}} $ </h5>


                        <div v-if="planLine.userLicenceData.options.length > 100">
                            <h5  class="content-heading align-center">{{textSubscriptionLicenceOptionSection[actualLanguage]}}</h5>
                            <div v-for="(optionLine2, optionIndex2) in planLine.userLicenceData.options" :key="optionIndex2" class="col-xm-12 col-md-12">
                              <h5 class="font-w200 text-center">{{optionLine2.title[actualLanguage]}}</h5>

                              <h6  class="font-w200 text-center">{{optionLine2.description[actualLanguage]}}</h6>
                              <h6  class="font-w200 text-center">{{optionLine2.priceDescription[actualLanguage]}}</h6>
                              <h6  class="h3 font-w700 push-10">{{optionLine2.price}} $ </h6>
                              
                            </div>
                        </div>
                      </div>
                      <hr size="50">


                      <!-- ================================================================= -->
                      <!-- Affichage de la charte de rabais de volume -->
                      <!-- ================================================================= -->
                      <div v-if="planLine.rebateChartData.chart.length > 0" class="col-sm-12 push">
                        <h4  class="font-w200 text-center">{{textRebateTableTitle[actualLanguage]}}</h4>
                        <h6  class="font-w200 text-center">{{textRebateTableSubTitle[actualLanguage]}}</h6>
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 30%;">{{textRebateTableColumn01[actualLanguage]}}</th>
                                    <th class="text-center" style="width: 30%;">{{textRebateTableColumn02[actualLanguage]}}</th>
                                    <th class="text-center" style="width: 30%;">{{textRebateTableColumn03[actualLanguage]}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(rebateSlice) in planLine.rebateChartData.chart">
                                    <td class="text-center">{{rebateSlice.priceSliceMin}} $</td>
                                    <td class="text-center">{{rebateSlice.priceSliceMax}} $</td>
                                    <td class="text-center">{{rebateSlice.pourcentageReduction}} %</td>
                                </tr>
                            </tbody>
                        </table>
                      </div>

                      <!-- ================================================================= -->
                      <!-- Affichage des rabais spéciaux -->
                      <!-- ================================================================= -->
                      <div v-for="(specialRebate) in planLine.specialRebate" class="col-sm-12 push">
                        <div v-if="specialRebate.RebateType == 'Pourcentage'" class="col-sm-12">
                          <h3  class="font-w200 text-center">{{specialRebate.RebateBillingDescription[actualLanguage]}}</h3>
                          <h4  class="font-w200 text-center">{{specialRebate.RebateAmount}}%</h4>
                          <h4  class="font-w200 text-center">Expire: {{specialRebate.ExpiringDate}}</h4>
                  
                        </div>
                        <div v-else class="col-sm-12">
                          <h3  class="font-w200 text-center">{{specialRebate.RebateBillingDescription[actualLanguage]}}</h3>
                          <h4  class="font-w200 text-center">{{specialRebate.RebateAmount}}$</h4>
                          <h4  class="font-w200 text-center">Expire: {{specialRebate.ExpiringDate}}</h4>
                        </div>
                      </div>


                      <div >

                        <h3>{{contactEVSensForSubscribe[actualLanguage]}}</h3>
                        <!--
                          //RETRAIT STRIPE
                          <span class="btn btn-default">
                            <button v-on:click="selectPlan(index)" class="btn btn-success" type="button"><i  class="fa fa-arrow-up push-5-r"></i>{{labelBtnSelectThisPlan[actualLanguage]}}</button>
                          </span>
                          -->
                      </div>

                  </div>
              </a>

              <!-- END Startup Plan -->
          </div>




        </div>
      </div>







      <!-- Affichage du plan choisi-->
      <div v-if="processState === 'ViewSelectedPlan'" class="block">
        <a class="block block-bordered block-link-hover3 text-center">

          <div class="col-lg-12">
              <a class="block block-link-hover2">
                  <div class="block-content block-content-full bg-flat clearfix">
                      <i class="fa fa-key fa-2x text-white pull-right"></i>
                      <span class="h2 text-white-op">{{selectedPlan.planInfo.title[actualLanguage]}}</span>
                  </div>
              </a>
          </div>

          <div class="block-content">
            <div class="block-header">
                <h3  class="font-w200 text-center">{{selectedPlanLicenceConfigurationTitle[actualLanguage]}}</h3>
            </div>
            <table class="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th class="text-center" style="width: 50%;">{{selectPlanOptionColumnTitle01[actualLanguage]}}</th>
                        <th class="text-center" style="width: 25%;">{{selectPlanOptionColumnTitle02[actualLanguage]}}</th>
                        <th class="text-center" style="width: 25%;">{{selectPlanOptionColumnTitle03[actualLanguage]}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center"><h5  class="font-w200 text-center">{{tableLicenceBaseCostDescription[actualLanguage]}}</h5></td>
                        <td class="text-center">---</td>
                        <td class="text-center">{{customizedOrganizationLicence.price}} $</td>
                        
                    </tr>
                    <tr v-for="(option) in customizedOrganizationLicence.options">
                        <td class="text-center"><h5  class="font-w200 text-center">{{option.title[actualLanguage]}}</h5>{{option.description[actualLanguage]}}</td>
                        
                        <td v-if="option.valueType=='NUMERIC'" class="text-center">
                          <h6  class="h6 font-w700 push-10">{{maxValueLabel[actualLanguage]}} </h6>
                          <input v-model="option.value" @change="computeCost()" class="form-control text-center"  placeholder="Valeur/Value">
                        </td>
                        <td v-if="option.valueType=='BOOL'" class="text-center">
                            <label class="css-input switch switch-success">
                              <input type="checkbox" checked v-model="option.value" @change="computeCost()">
                              <span></span> Activation
                            </label>                       
                        </td>

                        <td class="text-center">{{option.priceDescription[actualLanguage]}} : {{option.price}} $</td>
                    </tr>
                </tbody>
            </table>
          </div>


          <div v-for ="(userLicence,licenceIndex) in  customizedUserLicences" class="block-content">
            <div class="block-header">
                <h3  class="font-w200 text-center">{{selectedPlanUserLicenceConfigurationTitle[actualLanguage]}} : {{licenceIndex+1}}</h3>
            </div>
            <table class="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th class="text-center" style="width: 50%;">{{selectPlanOptionColumnTitle01[actualLanguage]}}</th>
                        <th class="text-center" style="width: 25%;">{{selectPlanOptionColumnTitle02[actualLanguage]}}</th>
                        <th class="text-center" style="width: 25%;">{{selectPlanOptionColumnTitle03[actualLanguage]}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center"><h5  class="font-w200 text-center">{{tableUserLicenceBaseCostDescription[actualLanguage]}}</h5></td>
                        <td class="text-center">---</td>
                        <td class="text-center">{{userLicence.price}} $</td>
                        
                    </tr>
                    <tr v-for="(option) in userLicence.options">
                        <td class="text-center"><h5  class="font-w200 text-center">{{option.title[actualLanguage]}}</h5>{{option.description[actualLanguage]}}</td>
                        
                        <td v-if="option.valueType=='NUMERIC'" class="text-center">
                          <h6  class="h6 font-w700 push-10">{{maxValueLabel[actualLanguage]}} </h6>
                          <input v-model="option.value" @change="computeCost()" class="form-control text-center"  placeholder="Valeur/Value">
                        </td>
                        <td v-if="option.valueType=='BOOL'" class="text-center">
                            <label class="css-input switch switch-success">
                              <input type="checkbox" checked v-model="option.value" @change="computeCost()">
                              <span></span> Activation
                            </label>                       
                        </td>

                        <td class="text-center">{{option.priceDescription[actualLanguage]}} : {{option.price}} $</td>
                    </tr>
                </tbody>
            </table>
          </div>
          <div class="block-header">
            <div class="col-sm-12 push">

                <div v-if="customizedUserLicences.length < parseFloat(selectedPlan.planInfo.maximumLicenceCount)" class="col-sm-6 col-xs-12">
                  <span class="btn btn-default">
                    <button v-on:click="addUserLicence()" class="btn btn-success" type="button"><i  class="fa fa-arrow-up push-5-r"></i>{{labelBtnAddUserLicence[actualLanguage]}}</button>
                  </span>
                </div>
                <div v-if="customizedUserLicences.length > parseFloat(selectedPlan.planInfo.includedLicence)" class="col-sm-6 col-xs-12">
                  <span class="btn btn-default">
                    <button v-on:click="removeUserLicence()" class="btn btn-success" type="button"><i  class="fa fa-arrow-up push-5-r"></i>{{labelBtnRemoveUserLicence[actualLanguage]}}</button>
                  </span>
                </div>              
            </div>
          </div>


          <!-- ================================================================= -->
          <!-- Affichage des rabais spéciaux du plan sélectionné-->
          <!-- ================================================================= -->
          <div class="block-header">
            <div v-for="(specialRebate) in selectedPlan.specialRebate" class="col-sm-12 push">
              <div v-if="specialRebate.RebateType == 'Pourcentage'" class="col-sm-12">
                <h3  class="font-w200 text-center">{{specialRebate.RebateBillingDescription[actualLanguage]}}</h3>
                <h4  class="font-w200 text-center">{{specialRebate.RebateAmount}}%</h4>
                <h4  class="font-w200 text-center">Expire: {{specialRebate.ExpiringDate}}</h4>
        
              </div>
              <div v-else class="col-sm-12">
                <h3  class="font-w200 text-center">{{specialRebate.RebateBillingDescription[actualLanguage]}}</h3>
                <h4  class="font-w200 text-center">{{specialRebate.RebateAmount}}$</h4>
                <h4  class="font-w200 text-center">Expire: {{specialRebate.ExpiringDate}}</h4>
              </div>
            </div>
          </div>






          <div class="block-header">

            <div class="col-lg-12">
                <a class="block block-link-hover2">
                    <div class="block-content block-content-full bg-flat clearfix">
                        <i class="fa fa-dollar fa-2x text-white pull-right"></i>
                        <span class="h2 text-white-op">{{textCostSimulationTitle01[actualLanguage]}}</span>
                    </div>
                </a>
            </div>

            <div class="col-sm-12 push">

              <div class="col-xm-12 col-sm-6 push">
                <h4  class="font-w200 text-center push">{{actualCostTitle[actualLanguage]}}</h4>
                <h5  class="font-w200 text-center push">{{actualCostDescriptionNoDevice[actualLanguage]}}</h5>
                <h6  class="h5 font-w700 push-10">{{labelBaseCost[actualLanguage]}} {{sumBaseCostNoDevice}} $ </h6>
                <h6  class="h5 font-w700 push-10">{{labelCostRebate[actualLanguage]}}{{sumRebateNoDevice}} $ </h6>
                <h6  class="h3 font-w700 push-10">{{labelMonthlyCostNoDevice[actualLanguage]}}{{sumFinalCostNoDevice}} $ </h6>
                <h6 v-if="specialRabateNoDevice > 0"  class="h3 font-w700 push-10">{{labelCostSpecialRebate[actualLanguage]}}{{specialRabateNoDevice}} $ </h6>
                <h6 v-if="specialRabateNoDevice > 0"  class="h3 font-w700 push-10">{{labelMonthlyCostNoDeviceSpecialRebate[actualLanguage]}}{{sumFinalCostWithSpecialRebateNoDevice}} $ </h6>
              </div>


              <div class="col-xm-12 col-sm-6 push">
                <h4  class="font-w200 text-center push">{{actualCostTitle[actualLanguage]}}</h4>
                <h5  class="font-w200 text-center push">{{actualCostDescription[actualLanguage]}}</h5>
                <h6  class="h5 font-w700 push-10">{{labelBaseCost[actualLanguage]}} {{sumBaseCost}} $ </h6>
                <h6  class="h5 font-w700 push-10">{{labelCostRebate[actualLanguage]}}{{sumRebate}} $ </h6>
                <h6  class="h3 font-w700 push-10">{{labelMonthlyCost[actualLanguage]}}{{sumFinalCost}} $ </h6>
                <h6 v-if="specialRabateNoDevice > 0"  class="h3 font-w700 push-10">{{labelCostSpecialRebate[actualLanguage]}}{{specialRabate}} $ </h6>
                <h6 v-if="specialRabateNoDevice > 0"  class="h3 font-w700 push-10">{{labelMonthlyCostSpecialRebate[actualLanguage]}}{{sumFinalCostWithSpecialRebate}} $ </h6>
              </div>
              
            </div>

            <div v-if="flagDisplayApplyPromoCodeButton==true"  class="col-xs-12 push">
              <p><button @click="applyPromoCode()" type="button" class="btn btn-success align-left" name="button">{{ButtonApplyPromoCode[actualLanguage]}}</button></p>
            </div>


            <div class="row push">
              <h3 class="block-title text-center" >{{validateLocalisation[actualLanguage]}}</h3>
              <div class="col-xs-12 col-md-6">
                    <div class="form-group">
                      <label class="col-xs-12" for="example-select">{{ selectMyCountry[actualLanguage] }}</label>
                      <div class="col-sm-12">
                          <select class="form-control" @click="selectActualCountry()" v-model=actualCountryIndex  size="1">
                              <option v-for="(country,countryIndex) in countryStateTaxRates" :value="countryIndex">{{country.StateTaxData.CountryName[actualLanguage]}}</option>
                          </select>
                      </div>
                  </div>
              </div>
              <div v-if="actualCountryIndex >= 0" class="col-xs-12 col-md-6">
                    <div class="form-group">
                      <label class="col-xs-12" for="example-select">{{ selectMyState[actualLanguage] }}</label>
                      <div class="col-sm-12">
                          <select class="form-control" @click="selectActualState()" v-model=actualStateIndex  size="1">
                              <option v-for="(state,stateIndex) in countryStateTaxRates[actualCountryIndex].StateTaxData.StateList" :value="stateIndex">{{state.Name[actualLanguage]}}</option>
                          </select>
                      </div>
                  </div>
              </div>
            </div>


            <div  class="col-xs-12">
              <p><button @click="confirmOrder()" type="button" class="h2 btn btn-success align-left" name="button">{{ButtonProceedOrder[actualLanguage]}}</button></p>
            </div>

          </div>


          <div class="col-sm-12">
              <span class="btn btn-default">
                <button v-on:click="unSelectPlan()" class="btn btn-success" type="button"><i  class="fa fa-arrow-up push-5-r"></i>{{labelBtnUnSelectThisPlan[actualLanguage]}}</button>
              </span>
          </div>



        </a>
      </div>


    </div>














    <!-- ===================================================================-->
    <!-- ===================================================================-->
    <!-- Description de la facture du premier payment-->
    <!-- ===================================================================-->
    <!-- ===================================================================-->
    <div v-if="planTransactionData.transactionStatusCode === '105'"  class="row">

      <div v-if= "planTransactionData.firstPaymentRebate > 0"  class="row">
          <h3 class="block-title text-center" >{{InvoiceHeaderFirst[actualLanguage]}}</h3>
      </div>
      <div v-else  class="row">
          <h3 class="block-title text-center" >{{InvoiceHeader[actualLanguage]}}</h3>
      </div>


      <div class="table-responsive push-50">
          <table class="table table-bordered table-hover">
              <thead>
                  <tr>
                      <th class="text-center" style="width: 50px;"></th>
                      <th>Produit</th>
                      <th class="text-center" style="width: 100px;">{{InvoiceQuantity[actualLanguage]}}</th>
                      <th class="text-right" style="width: 120px;">{{InvoiceUnitPrice[actualLanguage]}}</th>
                      <th class="text-right" style="width: 120px;">{{InvoicePrice[actualLanguage]}}</th>
                  </tr>
              </thead>
              <tbody>
                
                  <tr>
                      <td class="text-center">1</td>
                      <td>
                          <p class="font-w600 push-10">{{InvoiceEVSensServicePlan[actualLanguage]}}</p>
                          <div class="text-muted">{{selectedPlan.planInfo.title[actualLanguage]}} ({{InvoiceOrgLicenceText[actualLanguage]}} {{customizedUserLicences.length}} {{InvoiceOrgUserText[actualLanguage]}})</div>
                      </td>
                      <td class="text-center"><span class="badge badge-primary">1</span></td>
                      <td class="text-right">$ {{customizedOrganizationLicence.price}}</td>
                      <td class="text-right">$ {{customizedOrganizationLicence.price}}</td>
                  </tr>
                  

                  <tr v-if = "specialRabateNoDevice > 0">
                      <td class="text-center">2</td>
                      <td>
                          <p class="font-w600 push-10">{{InvoiceSpecialRebate[actualLanguage]}}</p>
                      </td>
                      <td class="text-center"><span class="badge badge-primary">1</span></td>
                      <td class="text-right">$ -{{this.specialRabateNoDevice}}</td>
                      <td class="text-right">$ -{{this.specialRabateNoDevice}}</td>
                  </tr>

                  <tr v-if = "selectedPlan.transactionCredit > 0">
                      <td class="text-center">3</td>
                      <td>
                          <p class="font-w600 push-10">{{InvoiceSubscriptionCredit[actualLanguage]}}</p>
                      </td>
                      <td class="text-center"><span class="badge badge-primary">1</span></td>
                      <td class="text-right">$ -{{this.selectedPlan.transactionCredit}}</td>
                      <td class="text-right">$ -{{this.selectedPlan.transactionCredit}}</td>
                  </tr>

                  <tr>
                      <td colspan="4" class="font-w600 text-right">{{InvoiceSubTotal[actualLanguage]}}</td>
                      <td class="text-right">$ {{sousTotal1}}</td>
                  </tr>

                  <tr v-for="(taxLine, index2) in actualTaxes01">
                      <td colspan="4" class="font-w600 text-right">{{taxLine.Label[actualLanguage]}}</td>
                      <td class="text-right">$ {{taxLine.Amount}}</td>
                  </tr>

                  <tr class="active">
                      <td colspan="4" class="font-w700 text-uppercase text-right">Total</td>
                      <td class="font-w700 text-right">$ {{total1}}</td>
                  </tr>
                  
              </tbody>
          </table>

          <div >
              <h6 class="block-title text-center" >{{InvoiceMonthlyFeesCondition[actualLanguage]}}</h6>
          </div>

          
      </div>


      <!-- END Description de la facture -->













<!--
                <tbody>
                    <tr>
                        <td class="text-center"><h5  class="font-w200 text-center">{{tableLicenceBaseCostDescription[actualLanguage]}}</h5></td>
                        <td class="text-center">---</td>
                        <td class="text-center">{{customizedOrganizationLicence.price}} $</td>
                        
                    </tr>
                    <tr v-for="(option) in customizedOrganizationLicence.options">
                        <td class="text-center"><h5  class="font-w200 text-center">{{option.title[actualLanguage]}}</h5>{{option.description[actualLanguage]}}</td>
                        
                        <td v-if="option.valueType=='NUMERIC'" class="text-center">
                          <h6  class="h6 font-w700 push-10">{{maxValueLabel[actualLanguage]}} </h6>
                          <input v-model="option.value" @change="computeCost()" class="form-control text-center"  placeholder="Valeur/Value">
                        </td>
                        <td v-if="option.valueType=='BOOL'" class="text-center">
                            <label class="css-input switch switch-success">
                              <input type="checkbox" checked v-model="option.value" @change="computeCost()">
                              <span></span> Activation
                            </label>                       
                        </td>

                        <td class="text-center">{{option.priceDescription[actualLanguage]}} : {{option.price}} $</td>
                    </tr>
-->









      <div class="col-xs-6">
        <p><button @click="cancelSelection()" type="button" class="btn btn-danger align-right" name="button">{{ButtonCancelSelection[actualLanguage]}}</button></p>
      </div>

      <div  class="col-xs-6">
        <p><button @click="showModal('stripe-paiement')" type="button" class="btn btn-success align-left" name="button">{{ButtonProceedPayment[actualLanguage]}}</button></p>
      </div>

    </div>
    <!-- END Table -->






    </div>



    </div>
   



  </div>
</template>

<script>

import _ from 'underscore'
import { mapState, mapActions } from 'vuex'

//RETRAIT STRIPE
//import StripePaiement from './StripePaiment'


export default {
  props: ['portData'],

  components: {
    ////RETRAIT STRIPE
    //StripePaiement
  },


  data() {
    return {
      displayDataTable : false,
      flagShowPlanList : false,

      processState : 'ViewPlanList',
      selectedPlan : {},
      customizedOrganizationLicence : {},
      customizedUserLicences : [],
      
      countryStateTaxRates : [],
      actualTaxes01:[],
      actualTaxes02:[],
      selectMyCountry: {FR: 'Pays:', EN: 'Country'},
      selectMyState: {FR: 'Province:', EN: 'State'},
      actualCountryIndex : -1,
      actualCountryName : 'ND',
      actualStateNames : {EN:'ND',FR:'ND'},
      actualStateIndex : -1,



      displaySelectedPlanFlag:false,
      acceptConditionFlag:false,
      actualLanguage : "FR",

      textSubscriptionDescriptionTitle01: {FR: "Abonnement d'organisation", EN: 'Organization subscription'},

      textSubscriptionDescriptionText01:{FR: "La plateforme gestionaire permet aux usagers d'une organisation de créer des Groupes et des Systèmes dans lesquels les modules de mesures et les appareils mesurés y sont enregistrés.",
                                         EN: "The manager platform allows to organization's users to create Groups and System in which monitoring module and monitored device are registered."},

      textSubscriptionDescriptionText02:{FR: "Ainsi, les usagers peuvent créer des arborescences de Groupes et de Systemes dans leur profil. Ces Groupes et Systèmes sont liés à l'organisation et donc les fonctionalités accessibles dépendent des licences d'accèes détenues par l'organisation.",
                                         EN: "Then users can creates an arborescence of Groups and Systems in their profile. These Groups and Systems are linked to the organization then accessible functionalities depends on access licences held by the organization."},
      
      textSubscriptionDescriptionText03:{FR: "Un abonnement d'organisation comporte une licence d'organisation à laquelle s'ajoute des licences d'utilisateur(s). Les licences utilisateurs sont ainsi alloués à des usagers afin de leur permettre l'accèes aux fonctionalités de la plateforme gestionaire.",
                                         EN: "An organization subscription includes an organization licence and user(s) licences. Users licences are thus allocated to users in order to allow them access to the functionalities of the manager platform."},
      
      textSubscriptionDescriptionText04:{FR: "Les frais d'abonnement comportent des frais mensuels fixes pour chaque licence incluses dans l'abonnement. Les frais mensuel sont composés de frais de base à lesquels peuvent s'ajouter des frais par options qui sont choisies (configurable).",
                                         EN: "The subscription fees have a fixed monthly fee for each licence included in the subscription. The monthly fees are composed of basic fees which can be added to fees of chosen options (congigurable)."},
      
      textSubscriptionDescriptionText05:{FR: "Les frais mensuel d'abonnement dependent aussi du nombre total d'appareils enregistrés dans les différents systèmes liés à l'organisation. Les administrateurs peuvent configurer une limite d'appareils enregistrable afin de limiter ou contrôler les coûts mensuel.",
                                         EN: "The monthly subscription fees also depend on the total number of devices registered in the various systems linked to the organization. Administrators can configure a recordable device limit to limit or control costs monthly."},
                   
      textSubscriptionDescriptionTitle02:{FR: "Utilisez plus et payé moins!", EN: 'Use more to pay less!'},
      
      textSubscriptionDescriptionText11:{FR: "Les frais d'abonnement affichés sont les frais de base pour chaque éléments. Lors de la facturation, un % de réduction, par tranche de coût, est appliquée à chaque tranche de coût total de base. Ainsi, plus vous utilisez de service et moins coûteux sont les services ajoutés!",
                                         EN: "The subscription fees shown are the base charges for each item. When invoicing, a % reduction per cost bracket is applied per base total cost bracket. So the more service you use, less expensive are the added services!"},

      textSubscriptionDescriptionText12:{FR: "Après avoir sélectioner un type d'abonnement, il vous est possible de simuler les côuts avec les options choisies.",
                                         EN: "After selecting a subscription type, you can simulate the costs with the options chosen"},
      
      textSubscriptionDescriptionTitle03:{FR: "Pour plus d'information consultez le document explicatif suivant:", EN: 'For more explanation, consult the following explanation document:'},     
    
      buttonLabelPlatformDucumentationExplanation:{FR: "Fonctionalités de la plateforme EL-iot.", EN: 'Functionalities of the EL-iot platform.'},

      textSubscriptionDescriptionTitle04: {FR: "Plans disponibles", EN: 'Available plans'},
      textSubscriptionOrgLicenceSection: {FR: "Licence de l'organisation", EN: 'Organisation licence'},
      textSubscriptionUserLicenceSection: {FR: "Licence utilisateur (additionelles)", EN: 'User licence (additional)'},
      textSubscriptionLicenceOptionSection: {FR: "Détails et options de la licence:", EN: 'Licence detail and options:'},

      textRebateTableTitle:{FR: "Charte de rabais de volume", EN: 'Volume rebate chart'},
      textRebateTableSubTitle:{FR: "Rabais par tranche de coût de base (mensuel).",
                               EN: 'Discount per base cost bracket (monthly).'},
      textRebateTableColumn01:{FR: "De:", EN: 'From:'},
      textRebateTableColumn02:{FR: "À:", EN: 'To:'},
      textRebateTableColumn03:{FR: "% Rabais", EN: '% Rebate'},


      labelBtnSelectThisPlan: {FR: "Sélectionner ce plan", EN: 'Select this plan'},

      contactEVSensForSubscribe: {FR: "Pour vous abonnez à ce forfait, contactez support@evsens.ca.",
                                   EN: 'To subscribe to this plan, contact support@evsens.ca.'},

      selectedPlanLicenceConfigurationTitle : {FR: "Configuration de la licence d'organisation", EN: 'Selected plan organization licence configuration'},
      tableLicenceBaseCostDescription : {FR: "Coûts de base de l'abonnement", EN: 'Subscription base cost'},
      selectPlanOptionColumnTitle01: {FR: "Description / Détails", EN: 'Description / Detail'},
      selectPlanOptionColumnTitle02: {FR: "Activation de l'option / Valeur maximum", EN: 'Option activation / Maximum value'},
      selectPlanOptionColumnTitle03: {FR: "Coût mensuel de base", EN: 'Monthly base cost'},
      maxValueLabel: {FR: "Valeur maximale (limite)", EN: 'Maximum value (limit)'},

      selectedPlanUserLicenceConfigurationTitle : {FR: "Configuration de la licence de l'usager", EN: 'Licence configuration for user'},
      tableUserLicenceBaseCostDescription : {FR: "Coûts de base de la licence usager", EN: 'User licence base cost'},
      
      labelBtnAddUserLicence: {FR: "Ajouter une licence usager", EN: 'Add user licence'},
      labelBtnRemoveUserLicence: {FR: "Retirer une licence usager", EN: 'Remove user licence'},


      textCostSimulationTitle01: {FR: "Estimateur de frais mensuel", EN: 'Monthly fees estimator'},
      actualCostTitle: {FR: "Estimation des coûts mensuels", EN: 'Monthly fees estimation'},
      actualCostDescriptionNoDevice: {FR: "Coûts mensuel avec les options choisies (sans les éléments chargés à la consommation).",
                             EN: 'Monthly fees with selected options (without element charged per units).'},
      actualCostDescription: {FR: "L'estimation suppose que les valeurs maximales sont atteintes. Il est possible d'estimer les coûts en modifiant les valeurs limites",
                             EN: 'The estimation assume cunsumption with maximum values reached. You can estimate cost for different maximum values.'},
      labelBaseCost: {FR: "Coûts de base : ", EN: 'Base cost : '},
      labelCostRebate: {FR: "Rabais de volume : ", EN: 'Volume rebate : '},
      labelCostSpecialRebate: {FR: "Rabais spécial : ", EN: 'Special rebate : '},
      labelMonthlyCostNoDevice: {FR: "Mensualité minimale : ", EN: 'Minimum monthly fees : '},
      labelMonthlyCost: {FR: "Mensualité si maximums atteint : ", EN: 'Monthly fees if maximas reached : '},
      labelMonthlyCostNoDeviceSpecialRebate: {FR: "Mensualité minimale avec rabais spécial : ", EN: 'Minimum monthly fees with special rebate : '},
      labelMonthlyCostSpecialRebate: {FR: "Mensualité si maximums atteint avec rabais spécial : ", EN: 'Monthly fees if maximas reached with special rebate : '},


      labelBtnUnSelectThisPlan: {FR: "Revenir au choix de plans", EN: 'Back to plan list'},
      labelBtnSignUp: {FR: "S'inscrire", EN: 'Sign up'},
      ButtonProceedOrder: {FR: "Procéder à l'achat", EN: 'Proceed to order'},
      validateLocalisation: {FR: 'Validez votre localisation:', EN: 'Validate your location:'},


      ButtonApplyPromoCode: {FR: "Appliquer un code promotionnel", EN: 'Apply promotional code'},
      ReadCodePromptMessage : {FR: "Introduire votre code promotionnel:", EN: 'Introduce your promotional code:'},
      ButtonProceedPayment: {FR: "Procéder au paiement", EN: 'Proceed to payment'},
      ButtonCancelSelection: {FR: "Annuler la sélection", EN: 'Cancel selection'},


      InvoiceHeaderFirst: {FR: "Détail de votre premier versement", EN: 'First payment detail'},
      InvoiceHeader: {FR: "Détail de vos versements mensuel*", EN: 'Monthly payment detail*'},
      InvoiceHeaderNext: {FR: "Détail de vos versements par la suite", EN: 'Next payment detail'},
      InvoiceOrgLicenceText:{FR: "1 Licence d'organisation + ", EN: '1 Organisation licence + '},
      InvoiceOrgUserText:{FR: "licence(s) usager(s) ", EN: 'user licence'},

      InvoiceSubscriptionCredit: {FR: "Crédit d'abonnement", EN: 'Subscription credit'},
      InvoiceSpecialRebate: {FR: "Rabais spécial", EN: 'Special rebate'},
      InvoiceQuantity: {FR: "Quantité", EN: 'Quantity'},
      InvoiceUnitPrice: {FR: "Prix unitaire", EN: 'Unit price'},
      InvoicePrice: {FR: "Prix", EN: 'Price'},
      InvoiceEVSensServicePlan: {FR: "Plan de service EV Sens", EN: 'EV Sens service plan'},
      InvoiceSubTotal: {FR: "Sous total", EN: 'Sub total'},
      InvoiceMonthlyFeesCondition: {FR: "*Si les maximums d'utilisation permettent d'enregistré plus d'appareils que le nombre inclue au forfait, des frais d'appareils additionnels peuvent s'ajouter à vos versement mensuel.",
                                     EN: '*If the usage limits allow you to register more devices than the number included in the package, additional device fees may be added to your monthly payment.'},


      flagDisplayApplyPromoCodeButton : true,
      sumBaseCostNoDevice : 0,
      sumRebateNoDevice : 0,
      sumFinalCostNoDevice : 0,
      specialRabateNoDevice : 0,
      sumFinalCostWithSpecialRebateNoDevice:0,

      sumBaseCost : 0,
      sumRebate : 0,
      sumFinalCost : 0,
      specialRabate : 0,
      sumFinalCostWithSpecialRebate:0,


      sousTotal1 : 0.00,
      total1:0.00,
      sousTotal2 : 0.00,
      total2: 0.00,
    }
  },

  computed: {
    ...mapState('sessionStore', ['planTransactionData','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),


    selectPlan(planIndex){
        //console.log('Select')
        this.selectedPlan = JSON.parse(JSON.stringify(this.planDescription[planIndex]))
        this.customizedOrganizationLicence = this.selectedPlan.organizationLicenceData
        this.customizedUserLicences = []
        this.flagDisplayApplyPromoCodeButton=true

        for (var n = 0; n < this.selectedPlan.planInfo.includedLicence; n++) {
            this.customizedUserLicences.push(JSON.parse(JSON.stringify(this.selectedPlan.userLicenceData)))
            this.customizedUserLicences[n].price = "0"
         }

        this.computeCost()
        this.processState = 'ViewSelectedPlan'
        //this.planTransactionData.transactionStatusCode = '105'
    },

    addUserLicence(){
      this.customizedUserLicences.push(JSON.parse(JSON.stringify(this.selectedPlan.userLicenceData)))
      this.computeCost()

    },

    removeUserLicence(){
      this.customizedUserLicences.pop()
      this.computeCost()

    },

    unSelectPlan(){
      this.processState = 'ViewPlanList'
      //this.planTransactionData.transactionStatusCode = '065'
    },

    applyPromoCode(){

      var requestData = { 'postAction':'ReadPromoCode',
                          'PromoCode': prompt(this.ReadCodePromptMessage[this.actualLanguage], ""),
                          }

      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          if(response.data.Code=='OK'){
            //console.log(response)
            //console.log(this.selectedPlan)
            this.flagDisplayApplyPromoCodeButton=false
            this.selectedPlan.specialRebate.push(response.data.SpecialRebate)
            this.computeCost()
            }
            else{
              window.alert(response.data.PromptMessage[this.actualLanguage])
            }
        })

    },


    computeCost(){
      this.sumBaseCost = 0
      this.sumBaseCost += parseFloat(this.customizedOrganizationLicence.price)

      this.sumBaseCostNoDevice = 0
      this.sumBaseCostNoDevice += parseFloat(this.customizedOrganizationLicence.price)


      for (var n = 0; n < this.customizedOrganizationLicence.options.length; n++) {
            if(this.customizedOrganizationLicence.options[n].valueType == 'BOOL' && this.customizedOrganizationLicence.options[n].value==true){
              this.sumBaseCost += parseFloat(this.customizedOrganizationLicence.options[n].price)
              this.sumBaseCostNoDevice += parseFloat(this.customizedOrganizationLicence.options[n].price)
            }

            if(this.customizedOrganizationLicence.options[n].valueType == 'NUMERIC'){
              var extraCount = parseFloat(this.customizedOrganizationLicence.options[n].value)-parseFloat(this.customizedOrganizationLicence.options[n].firstNoChargeCountValue)

              if(extraCount>0){
                this.sumBaseCost += parseFloat(this.customizedOrganizationLicence.options[n].price)*extraCount
              }
              
            }
         }

      for (var m = 0; m < this.customizedUserLicences.length; m++) {
        this.sumBaseCost += parseFloat(this.customizedUserLicences[m].price)
        this.sumBaseCostNoDevice += parseFloat(this.customizedUserLicences[m].price)
        for (var n = 0; n < this.customizedUserLicences[m].options.length; n++) {
              if(this.customizedUserLicences[m].options[n].valueType == 'BOOL' && this.customizedUserLicences[m].options[n].value==true){
                this.sumBaseCost += parseFloat(this.customizedUserLicences[m].options[n].price)
                this.sumBaseCostNoDevice += parseFloat(this.customizedUserLicences[m].options[n].price)
              }
              if(this.customizedUserLicences[m].options[n].valueType == 'NUMERIC'){
                this.sumBaseCost += parseFloat(this.customizedUserLicences[m].options[n].price)*parseFloat(this.customizedUserLicences[m].options[n].value)
              }
          }
      }

      this.sumBaseCost = Math.round(this.sumBaseCost*100)/100
      this.sumBaseCostNoDevice= Math.round(this.sumBaseCostNoDevice*100)/100

      var sliceMin = 0
      var sliceMax = 0
      var slicePourcentage = 0
      
      this.sumRebate = 0
      this.sumRebateNoDevice = 0

      for (var m = 0; m < this.selectedPlan.rebateChartData.chart.length; m++) {
        var sliceMin = parseFloat(this.selectedPlan.rebateChartData.chart[m].priceSliceMin)
        var sliceMax = parseFloat(this.selectedPlan.rebateChartData.chart[m].priceSliceMax)
        var slicePourcentage = parseFloat(this.selectedPlan.rebateChartData.chart[m].pourcentageReduction)/100

        //Computation on base cost which include device in base cost
        if(this.sumBaseCost>sliceMax){
          this.sumRebate += (sliceMax-sliceMin)*slicePourcentage
        }
        if(this.sumBaseCost >= sliceMin && this.sumBaseCost < sliceMax){
          this.sumRebate += (this.sumBaseCost-sliceMin)*slicePourcentage
        }
        if(m == (this.selectedPlan.rebateChartData.chart.length-1) && this.sumBaseCost > sliceMax){
          this.sumRebate += (this.sumBaseCost-sliceMax)*slicePourcentage
        }

        //Computation on base cost which DO NOT include devices cost
        if(this.sumBaseCostNoDevice>sliceMax){
          this.sumRebateNoDevice += (sliceMax-sliceMin)*slicePourcentage
        }
        if(this.sumBaseCostNoDevice >= sliceMin && this.sumBaseCostNoDevice < sliceMax){
          this.sumRebateNoDevice += (this.sumBaseCostNoDevice-sliceMin)*slicePourcentage
        }
        if(m == (this.selectedPlan.rebateChartData.chart.length-1) && this.sumBaseCostNoDevice > sliceMax){
          this.sumRebateNoDevice += (this.sumBaseCostNoDevice-sliceMax)*slicePourcentage
        }
      }

      this.specialRabateNoDevice = 0
      this.specialRabate = 0
      for (var m = 0; m < this.selectedPlan.specialRebate.length; m++) {
        var rebateAmmount = parseFloat(this.selectedPlan.specialRebate[m].RebateAmount)
        if(this.selectedPlan.specialRebate[m].RebateType=='Pourcentage'){
          this.specialRabateNoDevice = this.specialRabateNoDevice + Math.round(rebateAmmount*this.sumBaseCostNoDevice)/100
          this.specialRabate = this.specialRabate + Math.round(rebateAmmount*this.sumBaseCost)/100
        }else{
          this.specialRabateNoDevice = this.specialRabateNoDevice + rebateAmmount
          this.specialRabate = this.specialRabate + rebateAmmount
        }
      }

      this.sumFinalCost = this.sumBaseCost-this.sumRebate
      this.sumRebate = Math.round(this.sumRebate*100)/100
      this.sumFinalCost = Math.round(this.sumFinalCost*100)/100
      this.sumFinalCostWithSpecialRebate = Math.round((this.sumFinalCost-this.specialRabate)*100)/100

      this.sumFinalCostNoDevice=this.sumBaseCostNoDevice-this.sumRebateNoDevice
      this.sumRebateNoDevice = Math.round(this.sumRebateNoDevice*100)/100
      this.sumFinalCostNoDevice = Math.round(this.sumFinalCostNoDevice*100)/100
      this.sumFinalCostWithSpecialRebateNoDevice = Math.round((this.sumFinalCostNoDevice-this.specialRabateNoDevice)*100)/100
    },



    openAdministratorDocumentation() {
      var localUrl = ''
      if(this.actualLanguage = 'FR'){
        localUrl ='https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf';
        window.open(localUrl, '_blank');
      }
      if(this.actualLanguage = 'EN'){
        localUrl ='https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf';
        window.open(localUrl, '_blank');
      }           
      
    },

    cancelSelection(){
      this.displayYearToggleSelect = true
      this.displaySelectedPlanFlag = false
      this.planTransactionData.transactionStatusCode = '055'
      window.scrollTo(0, 0)

    },


    confirmOrder(){
      
      this.sousTotal1 = Math.round(Math.round(this.sumFinalCostWithSpecialRebateNoDevice*100)/100-this.selectedPlan.transactionCredit)
 
      var SumTax = 0
      var SumSubTotal = this.sousTotal1
      for (var n = 0; n < this.actualTaxes01.length; n++) {
        this.actualTaxes01[n].Amount = (Math.round(SumSubTotal*parseFloat(this.actualTaxes01[n].Rate)*100)/100).toString()
        if (this.actualTaxes01[n].CumulativeSubtotal){SumSubTotal += parseFloat(this.actualTaxes01[n].Amount)}
        SumTax += parseFloat(this.actualTaxes01[n].Amount)
      }
      this.total1= Math.round((this.sousTotal1 + SumTax)*100)/100



      this.sousTotal2 = Math.round(parseFloat(this.planTransactionData.renewalPrice)*100)/100
      SumTax = 0
      SumSubTotal = this.sousTotal2
      for (var n = 0; n < this.actualTaxes02.length; n++) {
        this.actualTaxes02[n].Amount = (Math.round(SumSubTotal*parseFloat(this.actualTaxes02[n].Rate)*100)/100).toString()
        if (this.actualTaxes02[n].CumulativeSubtotal){SumSubTotal += parseFloat(this.actualTaxes02[n].Amount)}
        SumTax += parseFloat(this.actualTaxes02[n].Amount)
      }
      this.total2= Math.round((this.sousTotal2 + SumTax)*100)/100

      this.$nextTick(() => {this.planTransactionData.transactionStatusCode = '105'});

      
      this.planTransactionData.postAction = 'NewOrganizationSubscription'
      this.planTransactionData.organizationSubscription = {'planDescription':this.selectedPlan,
                                                            'customizedOrganizationLicence':this.customizedOrganizationLicence,
                                                            'customizedUserLicences':this.customizedUserLicences}
      window.scrollTo(0, 0)

      //The transaction is finalised in the StripePaiment vue, it call the processSubscription call
      //and request content is planTransactionData


      //console.log('Plan Description:')
      //console.log(this.selectedPlan)
      //console.log('Customized Org Licence:')
      //console.log(this.customizedOrganizationLicence)
      //console.log('Custimized User Licence:')
      //console.log(this.customizedUserLicences)
    },



    getAdminPlanList(){
      //console.log('--CALL GET PLAN LIST---')
      var requestData = { 'postAction':'GetAdminPlanList',
                          'subscriptionListId': process.env.VAR_PLAN_ADMIN_LIST,
                          'organizationId':this.planTransactionData.organizationId,
                          }

      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          if(response.data.Code=='OK'){
            //console.log('--PLAN LIST---')
            //console.log(requestData)
            //console.log(response.data)
            this.planDescription = response.data.PlanList
            this.flagShowPlanList = true
            }
        })
    },


    getCountryStateTaxList(){
      var requestData = { 'postAction':'GetCountryTaxRates',
                          }
      //console.log(requestData)
      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          //console.log(response.data)
          if(response.data.Code=='OK'){
            //CountryList = [{'Country':'','StateTaxData':[]}]
            this.countryStateTaxRates = response.data.CountryList
            
            //Application by default the Canada:Quebec Tax rate
            for (var n = 0; n < this.countryStateTaxRates.length; n++) {
              if(this.countryStateTaxRates[n].Country == 'Canada'){
                for(var m = 0; m < this.countryStateTaxRates[n].StateTaxData.StateList.length; m++){
                  if(this.countryStateTaxRates[n].StateTaxData.StateList[m].Name.EN=='Quebec'){
                    this.actualCountryName = this.countryStateTaxRates[n].Country
                    this.actualStateNames = this.countryStateTaxRates[n].StateTaxData.StateList[m].Name
                    this.actualTaxes01 = structuredClone(this.countryStateTaxRates[n].StateTaxData.StateList[m].Taxes)
                    this.actualTaxes02 = structuredClone(this.countryStateTaxRates[n].StateTaxData.StateList[m].Taxes)
                  }
                }
              }
            }

            }
        })
    },

    selectActualCountry(){
      this.actualStateIndex = -1
      this.planTransactionData.taxRateData = {'countrySortKey':'Canada',
                                        'stateNames':{FR:'Québec',EN:'Quebec'}}
    },

    selectActualState(){
      if(this.actualCountryIndex >= 0 & this.actualStateIndex>=0){
        this.actualCountryName = this.countryStateTaxRates[this.actualCountryIndex].Country
        this.actualStateNames = this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Name
        this.actualTaxes01 = structuredClone(this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Taxes)
        this.actualTaxes02 = structuredClone(this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Taxes)

        this.planTransactionData.taxRateData = {'countrySortKey':this.actualCountryName,
                                                'stateNames':this.actualStateNames}

      }
    },


  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    this.planTransactionData.taxRateData = {'countrySortKey':'Canada',
                                      'stateNames':{FR:'Québec',EN:'Quebec'}}


    this.getAdminPlanList()
    this.getCountryStateTaxList()

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    window.scrollTo(0, 0)

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// AdminPlanTable.vue?093b8c5a